module.exports = __webpack_public_path__ + "static/img/new-img03.df791d23.webp";